export let NavMenuKeys;

(function (NavMenuKeys) {
  NavMenuKeys["Dashboard"] = "dashboard";
  NavMenuKeys["Fund"] = "fund";
  NavMenuKeys["Settings"] = "settings";
  NavMenuKeys["Activity"] = "activity";
  NavMenuKeys["Project"] = "project";
  NavMenuKeys["Operation"] = "operation";
  NavMenuKeys["Finance"] = "finance";
  NavMenuKeys["Stock"] = "stock";
  NavMenuKeys["Trade"] = "trade";
  NavMenuKeys["Game"] = "game";
  NavMenuKeys["Shop"] = "shop";
})(NavMenuKeys || (NavMenuKeys = {}));